<div class="fast-checkin-duration-container mt-4">
  <div class="content-wrapper">
    <!-- <div class="mb-4 mt-4">{{ welcomeTextTranslationKey | translate }}</div> -->
    <form id="fastCheckinUserInfoForm" [formGroup]="userInfoForm" (ngSubmit)="onNext()" autocomplete="off">
      <div class="form-row row">
        <div class="form-group col-md-12">
          <label for="zone" class="control-label">{{ 'i18n.shared.fields.zone' | translate }}</label>
          <input id="zone" name="zone" type="text" class="form-control" [value]="zoneName" disabled>
        </div>
      </div>
      <div class="form-row row">
        <div class="form-group col-md-12">
          <label for="controlPlate" class="control-label required">{{ 'i18n.shared.fields.control-plate' | translate }}</label>
          <input id="controlPlate" name="controlPlate" type="text" autocomplete="off" class="form-control text-uppercase" formControlName="controlPlate" autocapitalize="characters">
          <app-error-messages [control]="userInfoForm.controls.controlPlate"></app-error-messages>
        </div>
      </div>

      <div class="form-row row">
        <div class="form-group col-md-12">
          <label for="email" class="control-label">
            {{ 'i18n.shared.fields.email' | translate }}
          </label>
          <small class="text-muted email-info">
            {{ emailInfoTextTranslationKey | translate }}
          </small>
          <input id="email" name="email" type="email" autocomplete="off" class="form-control" formControlName="email">
          <app-error-messages [control]="userInfoForm.controls.email"></app-error-messages>
        </div>
      </div>

      <div class="button-container">
        <div class="form-row row">
          <div class="form-group col-12">
            <div class="d-grid">
              <button type="submit" class="btn btn-primary" [disabled]="userInfoForm.invalid">
                {{ 'i18n.shared.next' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
